// extracted by mini-css-extract-plugin
module.exports = {"recommendSlider":"recommendSlider","recommendSlider__titleArea":"recommendSlider__titleArea"};